/**
 * Negative Stock Exception Configs
 *
 * Covers the negative-stock pair:
 *   - ex-inv-ls-negative-stock-business: business-wide total < 0 (one row
 *     per product, no outlet column populated). High-impact signal.
 *   - ex-inv-ls-negative-stock-outlet: per-(product, outlet) negative,
 *     scoped to products whose business total is still positive. Lower
 *     priority (usually transfer-in-flight noise).
 *
 * Both use the shared product-exception layout. Per-outlet avg-cost and
 * stock columns come from `row.outlet_costs`.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const negativeStockBusinessConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-negative-stock-business'],
  primaryErrorCode: 'negative_stock_business',
  defaultSortColumn: 'total_stock',
  defaultSortDirection: 'asc',
  rowKeyField: 'row_key',
  // Stock-driven: lead each outlet cell with stock count, avg cost below.
  outletMode: 'stock',
})

export const negativeStockOutletConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-negative-stock-outlet'],
  primaryErrorCode: 'negative_stock',
  defaultSortColumn: 'total_stock',
  defaultSortDirection: 'asc',
  rowKeyField: 'row_key',
  // Stock-driven: lead each outlet cell with stock count, avg cost below.
  outletMode: 'stock',
})
